(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-bestseller-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mw-bestseller-hero')) {
    customElements.define('mw-bestseller-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.startAutoplay?.(); return; }
        this.initialized = true;
        this.index = 0;
        this.slides = Array.from(this.querySelectorAll('[data-slide-id]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        const show = (index) => {
          this.index = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
          this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = `${this.index + 1} / ${this.slides.length}`;
        };
        this.querySelector('[data-prev]')?.addEventListener('click', () => show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => show(this.index + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
        this.querySelector('nav')?.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.dots[this.index]?.focus();
        });
        let touchX = 0;
        let touchY = 0;
        this.addEventListener('touchstart', (event) => {
          if (!event.target.closest('.mw-sales-hero__visual, .mw-sales-hero__artwork')) return;
          touchX = event.changedTouches[0].clientX;
          touchY = event.changedTouches[0].clientY;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (!event.target.closest('.mw-sales-hero__visual, .mw-sales-hero__artwork')) return;
          const dx = event.changedTouches[0].clientX - touchX;
          const dy = event.changedTouches[0].clientY - touchY;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
        this.autoplayPaused = false;
        this.stopAutoplay = () => { clearInterval(this.autoplayTimer); };
        this.startAutoplay = () => {
          this.stopAutoplay();
          if (this.slides.length < 2 || this.autoplayPaused || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          this.autoplayTimer = setInterval(() => show(this.index + 1), (Number(this.dataset.autoplaySeconds) || 10) * 1000);
        };
        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);
        this.addEventListener('focusin', this.stopAutoplay);
        this.addEventListener('focusout', () => queueMicrotask(this.startAutoplay));
        this.addEventListener('click', () => this.startAutoplay());
        const toggle = this.querySelector('[data-autoplay-toggle]');
        toggle?.addEventListener('click', () => {
          this.autoplayPaused = !this.autoplayPaused;
          toggle.setAttribute('aria-pressed', String(this.autoplayPaused));
          toggle.querySelector('span').textContent = this.autoplayPaused ? '▶' : 'Ⅱ';
          this.startAutoplay();
        });
        this.visibilityHandler = () => this.startAutoplay();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.addEventListener('shopify:block:select', (event) => {
          this.autoplayPaused = true;
          this.stopAutoplay();
          const index = this.slides.findIndex(slide => slide.dataset.slideId === event.detail.blockId);
          if (index >= 0) show(index);
        });
        this.addEventListener('shopify:block:deselect', () => { this.autoplayPaused = false; this.startAutoplay(); });
        this.startAutoplay();
      }
      disconnectedCallback() {
        this.stopAutoplay?.();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pvt-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mw-tabs]').forEach((tabs) => {
    const buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
    const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));
    const activate = (button) => {
      buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== button.getAttribute('aria-controls');
      });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = (index + direction + buttons.length) % buttons.length;
        buttons[next].focus();
        activate(buttons[next]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pvt-image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mw-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('.mw-hero__slide'));
    const dots = Array.from(carousel.querySelectorAll('.mw-hero__dot'));
    const arrows = Array.from(carousel.querySelectorAll('.mw-hero__arrow'));
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== active; });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', String(selected));
      });
    };
    const schedule = () => {
      window.clearInterval(timer);
      if (carousel.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show(active + 1), Number(carousel.dataset.interval));
    };
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideIndex)); schedule(); }));
    arrows.forEach((arrow) => arrow.addEventListener('click', () => { show(active + (arrow.dataset.direction === 'next' ? 1 : -1)); schedule(); }));
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', schedule);
    schedule();
  });

  } catch(e) { console.error(e); }
})();
})();
